export enum ApiState {
    INITIAL = 'INITIAL',
    INITIALIZING = 'INITIALIZING',
    INITIALIZED = 'INITIALIZED',
    ERROR = 'ERROR',
    DEINITIALIZING = 'DEINITIALIZING',
    DEINITIALIZED = 'DEINITIALIZED'
}